import NavBar from "../NavBar/navBar";
const Taaruf = () => {
    return (
        <>
            <NavBar />
            <div className=" px-8 py-5">
                <h1 className="font-bold text-3xl my-6">Taaruf</h1>
            </div>
        </>
    )
}

export default Taaruf;